<template lang="html">
    <transition
        name="noti"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
    >
        <div
            v-if="active"
            ref="noti"
            :style="stylex"
            :class="[`vs-noti-${position}`,`vs-noti-${color}`,{'activeNoti':active}]"
            class="vs-component vs-notifications"
            @mouseover="pause"
            @mouseout="timerInit"
        >
            <div class="flex items-end" style="opacity: .3">
                <vs-progress :percent="progress" color="primary"/>
            </div>

            <div>
                <div class="flex items-center justify-between">
                    <div class="flex items-center content-noti justify-start">
                        <vs-icon
                            v-if="icon"
                            :icon="icon"
                            :icon-pack="iconPack"
                            class="vs-icon-noti"
                        ></vs-icon>
                        <h3 v-html="title"/>
                    </div>
                    <vs-button
                        class="mr-1"
                        color="primary"
                        size="small"
                        type="filled"
                        icon="close"
                        @click="clickNoti"
                    ></vs-button>
                </div>
                <div>
                    <div class="con-text-noti">
                        <p v-html="text"/>
                        <slot/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data: () => ({
        progress: 100,
        fullWidth: false,
        icon: null,
        iconPack: 'material-icons',
        color: 'primary',
        colorText: 'rgb(255, 255, 255)',
        active: true,
        text: null,
        title: null,
        position: 'bottom-right',
        time: 3000,
        cords: {
            top: null,
            left: null,
            right: null,
            bottom: null,
        },
        widthx: 0,
        fixed: false,
        timer: 3000,
        timeout: null

    }),
    computed: {
        fillingStyle() {
            return {
                left: this.cords.left ? '-100px' : null,
                right: this.cords.right ? '-100px' : null,
                background: this.color,
                height: `${this.widthx * 2}px`,
                width: `${this.widthx * 2}px`,
            }
        },
        stylex() {
            return {
                ...this.cords,
                color: this.colorText,
                width: this.fullWidth ? `calc(100% - 14px)` : ``,
                maxWidth: this.fullWidth ? 'none' : `350px`,
                background: `rgba(var(--vs-${this.color}), 1)`,
                minWidth: '250px'
            }
        }
    },

    created() {
        setTimeout(() => {
            this.moverNotis()
        }, 0);
        this.changeCords()
    },
    mounted() {
        this.timer = this.time

        setTimeout(() => {
            this.widthx = this.$refs.noti.clientWidth
        }, 0);

        if (!this.fixed) {
            this.timerInit()
        }
    },
    methods: {
        setProgress() {
            this.progress = this.timer / this.time * 100;
        },
        pause() {
            clearTimeout(this.timeout)
        },
        timerInit() {
            this.timeout = setTimeout(() => {
                this.timer = this.timer - 1000
                this.progress = this.timer / this.time * 100;

                if (this.progress === 0) {
                    this.active = false
                    clearTimeout(this.timeout)
                } else {
                    this.timerInit()
                }
            }, 1000);
        },
        clickNoti() {
            this.active = false
            this.click ? this.click() : null
            this.pause()
            this.setProgress()
        },
        beforeEnter(el) {
            el.style.opacity = 0
        },
        enter(el, done) {
            el.style.opacity = 1
            done()
        },
        leave(el, done) {
            el.style.opacity = 0
            let transformx = el.style.transform
            if (this.cords.left === '50%' || this.fullWidth) {
                transformx += ` translateY(${this.cords.top ? '-' : ''}100%)`
            } else {
                transformx += ` translateX(${this.cords.left ? '-' : ''}100%)`
            }
            el.style.transform = transformx
            setTimeout(() => {
                done()
                this.moverNotis()
            }, 150);
        },
        closeNoti() {
            this.active = false
        },
        changeCords() {
            let positions = this.position.split('-')
            let search = (text) => {
                return positions.indexOf(text) !== -1
            }
            if (search('top')) {
                this.cords.top = '0px'
            }
            if (search('bottom')) {
                this.cords.bottom = '0px'
            }
            if (search('right')) {
                this.cords.right = '0px'
            }
            if (search('left')) {
                this.cords.left = '0px'
            }

            if (search('center')) {
                this.cords.left = '50%'
            }
        },
        moverNotis() {
            let notisx = document.querySelectorAll('.vs-noti-' + this.position);
            for (var i = 0; i < notisx.length; i++) {
                let hx = 10
                for (var i2 = 0; i2 < i; i2++) {
                    hx += notisx[i2].clientHeight + 6
                }
                if (this.position.search('center') === -1) {
                    if (this.position.search('top') !== -1) {
                        notisx[i].style.transform = `translatey(${hx}px)`
                    } else if (this.position.search('bottom') !== -1) {
                        notisx[i].style.transform = `translatey(-${hx}px)`
                    }
                }

                if (this.position.search('top') !== -1 && this.position.search('center') !== -1) {
                    notisx[i].style.transform = `translate(-50%,${hx}px)`
                    notisx[i].style.zIndex = 10000 - i
                }
                if (this.position.search('bottom') !== -1 && this.position.search('center') !== -1) {
                    notisx[i].style.transform = `translate(-50%,-${hx}px)`
                    notisx[i].style.zIndex = 10000 - i
                }
            }
        }
    }
}
</script>
